/* global _ */
const AvailableIndices = [
  ['pv', '浏览量(PV)'],
  ['uv', '访客数(UV)'],
  ['ipnum', 'IP'],
  ['newvst', '新独立访客'],
  ['jrate', '跳出率'],
  ['atime', '平均访问时长'],
  ['anum', '平均访问页数'],
  ['vnum', '访问次数'],
  ['tnum', '自定义转化次数'],
  ['trate', '转化率'],
  ['innum', '入口页次数'],
  ['exitnum', '退出页次数'],
  ['exitrate', '退出率'],
  ['adcpc', 'CPC'],
  ['adcost', '消费'],
  ['adpv', '展现量'],
  ['adclick', '点击量'],
  ['adctr', '点击率'],
  ['adcpm', 'CPM'],
  ['income', '转化价值'],
  ['snum', '搜索指数'],
  ['uvrate', '访客渗透'],
  ['ordernum', '订单量'],
  ['orderprice', '订单金额'],
  ['orderrate', '订单转化率'],
  ['reg', '注册量'],
  ['regrate', '注册转化率'],
  ['reachrate', '到达率']
]

export default {
  getIndexName (abbr) {
    const t = _.find(AvailableIndices, {
      0: abbr
    })
    return t ? t[1] : ''
  },
  timeFormate (value) {
    if (isNaN(parseFloat(value))) {
      return '-'
    }
    const t = Math.ceil(value)
    let h, m, i
    h = m = i = 0
    i = t % 60
    if (t / 60 >= 1) {
      m = parseInt((t % 3600) / 60)
    }
    if (m) {
      h = parseInt(t / 3600)
    }
    return (
      `${h < 10 ? `0${h}` : h
      }:${
        m < 10 ? `0${m}` : m
      }:${
        i < 10 ? `0${i}` : i}`
    )
  }
}



// WEBPACK FOOTER //
// ./src/script/tool.js